angular.module('impactx.approval').controller('ApprovalDetailInvoiceCtrl', ['$scope', 'selectedListItems', 'dataGen', '$controller', '$routeParams', ApprovalDetailInvoiceCtrl]);
function ApprovalDetailInvoiceCtrl($scope, selectedListItems, dataGen, $controller, $routeParams) {
    $controller('ApprovalDetailCtrl', {$scope: $scope, backRoute: null});

    var atiId;
    if(!isUndefined($routeParams.id))
    {
        atiId = $routeParams.id;
    }
    else
    {
        atiId = selectedListItems.getFirstSelectedId();
    }
    $scope.getPageData = function() {
        dataGen.getData($scope, {id: atiId}, "/approval/view", function() {
        });

    };
    $scope.getDataForItemAction = function() {
        return {
            BLH_Id: $scope.data.approval.headerId,
            BLI_Ids: $scope.selectedItems,
            type: "bli",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForHeaderAction = function() {
        return {
            BLH_Id: $scope.data.approval.headerId,
            type: "blh",
            id: $scope.data.approval.id
        };
    };
    $scope.getDataForItemActionOneItem = function(item) {
        return {
            BLH_Id: $scope.data.approval.headerId,
            BLI_Ids: [{id: item.id}],
            type: "bli",
            id: $scope.data.approval.id
        };
    };

    $scope.showCateringDialog = function (event) {

    }

    $scope.getPageData();
}